import Vue from 'vue'
import { apiBasicAddressGetDefault, ApiBasicAddressListResponse } from '@/api'
import { Loading } from 'vant'
import { navigateTo, router } from '@/router'
import { RequiredDeep } from 'vtils/types'

export type Address = RequiredDeep<ApiBasicAddressListResponse>['list'][0]

export class AddressBridge {
  static getInitialLocation(): Address {
    return {
      province: '贵州省',
      provinceCode: '520000',
      city: '贵阳市',
      cityCode: '520100',
      county: '观山湖区',
      districtCode: '520115',
    } as Address
  }

  static async getCurrentLocation(): Promise<Address> {
    const currentLocation: Address =
      localStorage.getItem('__currentLocation__') &&
      localStorage.getItem('__currentLocation__') !== 'undefined' &&
      JSON.parse(localStorage.getItem('__currentLocation__') || '{}')
    if (currentLocation && currentLocation.id) {
      return currentLocation
    }
    const defaultAddress = await AddressBridge.getDefaultAddress()
    if (defaultAddress && defaultAddress.id) {
      return defaultAddress
    }
    return this.getInitialLocation()
  }

  static async getCurrentLocationText(): Promise<{
    currentLocation: Address
    currentLocationText: string
  }> {
    const currentLocation = await this.getCurrentLocation()
    const currentLocationText = `${currentLocation.province} ${currentLocation.city} ${currentLocation.county}`
    return {
      currentLocation: currentLocation,
      currentLocationText: currentLocationText,
    }
  }

  static setCurrentLocation(location: Address) {
    localStorage.setItem('__currentLocation__', JSON.stringify(location))
  }

  static getDefaultAddress(
    defaultValue = undefined,
  ): Promise<Address | undefined> {
    return apiBasicAddressGetDefault(
      { districtCode: '' },
      { noErrorToast: true, ignore403: true },
    ).then(
      res => (res && res.id ? res : defaultValue),
      () => defaultValue,
    ) as any
  }

  private static chosenAddress: Address | undefined

  static setChosenAddress(address: Address | undefined) {
    AddressBridge.chosenAddress = address

    console.log('进来了')
  }

  static async chooseAddress(
    goodsIds: string[] = [],
    addressId: string,
  ): Promise<Address | undefined> {
    return new Promise<Address | undefined>(resolve => {
      // AddressBridge.setChosenAddress(undefined)
      const fromPageName = router.currentRoute.name
      const off = router.beforeEach((to, from, next) => {
        if (to.name === fromPageName) {
          off()
          resolve(AddressBridge.chosenAddress)
        }
        next()
      })
      navigateTo('AddressIndex', {
        goodsIds: JSON.stringify(goodsIds),
        addressId,
      })
    })
  }
}

export const CurrentLocationText = Vue.extend({
  data: () => ({
    location: {},
    text: '',
  }),

  mounted() {
    ;(this as any).updateText()
  },

  activated() {
    ;(this as any).updateText()
  },

  methods: {
    async updateText() {
      const { currentLocation, currentLocationText } =
        await AddressBridge.getCurrentLocationText()
      this.location = currentLocation
      this.text = currentLocationText
    },
  },

  watch: {
    text: {
      immediate: true,
      handler(text) {
        if (text) {
          this.$emit('change', this.location)
        }
      },
    },
  },

  render(h) {
    return h('span', [
      this.text ||
        h(Loading, {
          props: {
            size: 18,
          },
        }),
    ])
  },
})
